import {  useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../common/store";
import useChangeUrl from "./use-change-url";
import { useHeartBeat } from "./heartbeat/use-heartbeat";
import { useNavigateAndHighlight } from "./use-navigate-and-highlight";
import { sendMessageLogSubmission } from "../../common/store/chat/thunks/send-message-log";
import getMessageByVurablizeEvent from "../utils/get-message-by-vurablize-event";
import VurbalizeEvents from "../../common/types/dto/chat/vurbalize-events";
import { getIpAddress } from "../../common/store/app-state/thunks/get-ip-address";

// import { sixthSenseData } from "../../mock-data/sixth-sense";

const useInitApp = () => {
  const dispatch = useAppDispatch();
  const { highlightAndScroll } = useNavigateAndHighlight();
  const isReadyHeartbeat = useAppSelector(state => state["app-state"].isReadyHeartbeat)

  useChangeUrl();
  useHeartBeat();
  // useClickListener();
  // useBeacon();


  // if the key exists don't update it
  // if (!localStorage.getItem("_6senseCompanyDetailsvoa")) {
  //   localStorage.setItem(
  //     "_6senseCompanyDetailsvoa",
  //     JSON.stringify(sixthSenseData)
  //   )
  // }

  useEffect(() => {
    highlightAndScroll(500);
  }, [highlightAndScroll]);

  useEffect(() => {
    dispatch(getIpAddress());
  }, [])

  useEffect(() => {
    if (!isReadyHeartbeat) return;
    dispatch(sendMessageLogSubmission({
      data: {
        message: getMessageByVurablizeEvent(VurbalizeEvents.NEW_PAGE_NAVIGATION),
        event_name: VurbalizeEvents.NEW_PAGE_NAVIGATION,
        event_data: {
          timestamp: Date.now(),
          pageUrl: window.location.href,
        },
      }
    }));
  }, [isReadyHeartbeat])
}

export default useInitApp;
